import {Mapper} from '@s-ui/domain'

export class FromCaptchaStatusResponseToCaptchaFormValueObjectMapper extends Mapper {
  constructor({captchaStatusFormValueObjectFactory}) {
    super()
    this._captchaStatusFormValueObjectFactory = captchaStatusFormValueObjectFactory
  }

  map = response => {
    const {siteKey} = response

    return this._captchaStatusFormValueObjectFactory({
      siteKey
    })
  }
}
